import CheckIcon from '@mui/icons-material/Check'
import AddIcon from '@mui/icons-material/Add'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import CloseIcon from '@mui/icons-material/Close'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import type { SvgIconComponent } from '@mui/icons-material'
import type { AffexyTokens } from '@/theme/affexyTokens'
import type { ActivityKind } from './dashboardTypes'

/** Icon + accent colour per activity kind, shared by the dashboard card and the Activity tab. */
export function activityMeta(c: AffexyTokens['colors']): Record<ActivityKind, { Icon: SvgIconComponent; color: string }> {
  return {
    completed: { Icon: CheckIcon, color: c.success },
    createdStudy: { Icon: AddIcon, color: c.coral },
    reachedRespondents: { Icon: StarBorderIcon, color: c.warning },
    abandoned: { Icon: CloseIcon, color: c.danger },
    started: { Icon: PlayArrowIcon, color: c.coral },
    publishedReport: { Icon: PictureAsPdfOutlinedIcon, color: c.ink },
    editedQuestion: { Icon: EditOutlinedIcon, color: c.ink56 },
  }
}
